import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { SelectValue } from 'antd/lib/select';
import WORK_UNIT_STATUS from 'src/enums/workUnitsStatus';

const { Option } = Select;

type StatusWUFilterProps = {
  onStatusUpdate: (value: string) => void;
  isReset?: boolean;
  setReset: (value: boolean) => void;
};

const StatusWUFilter: React.FC<StatusWUFilterProps> = ({ isReset = false, onStatusUpdate, setReset }) => {
  const [filterStatusValue, setFilterStatusValue] = useState<string[]>([]);
  const status: string[] = Object.keys(WORK_UNIT_STATUS);

  const onStatusFilterChange = (value: SelectValue) => {
    const newValue = String(value || '');
    setFilterStatusValue(value as string[]);
    onStatusUpdate(newValue);
  };

  useEffect(() => {
    if (isReset) {
      setFilterStatusValue([]);
      setReset(false);
    }
  }, [isReset, setReset]);

  return (
    <div>
      <p style={{ fontSize: '12px', marginBottom: '3px' }}>Status</p>
      <Select
        placeholder="Select Status"
        onChange={onStatusFilterChange}
        value={filterStatusValue}
        showArrow={true}
        allowClear
      >
        {status.map((type: string) => (
          <Option key={`status_${type}`} value={WORK_UNIT_STATUS[type as keyof typeof WORK_UNIT_STATUS]}>
            {type}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default StatusWUFilter;
